/**
 * Contact 토픽 — `/contact` 의 Topic 셀렉트와 그 토픽으로 들어오는 링크가 같이 쓴다.
 *
 * value 는 백오피스(InquiryManagement/InquiryDetail 의 CATEG_LABEL)와 1:1 이다 — 여기에
 * 항목을 넣으면 그 두 곳도 같이 넣는다. 백엔드 `categ` 는 자유 문자열이라 서버 변경은 없다.
 */

/** Works with 페이지의 "Add or correct a device" 가 여는 토픽 */
export const WORKS_WITH_TOPIC = 'worksWithDevice'

export const contactTopicList: { value: string; label: string }[] = [
	{ value: 'productInquiries', label: 'Product Inquiries' },
	{ value: 'orderSupport', label: 'Order Support' },
	{ value: 'warrantyRepair', label: 'Warranty & Repair' },
	{ value: 'softwareInquiries', label: 'Software' },
	{ value: WORKS_WITH_TOPIC, label: 'Works with: Add or Correct a Device' },
	{ value: 'dealerWholesale', label: 'Dealer & Wholesale' },
	{ value: 'collaborationOpportunities', label: 'Collaboration Opportunities' },
	{ value: 'feedbackSuggestions', label: 'Feedback & Suggestions' },
	{ value: 'otherQuestions', label: 'Other Questions' },
]

/**
 * 토픽별 Message 템플릿. 토픽을 고르면 Message 가 비어 있거나 다른 템플릿 그대로일 때만 채운다 —
 * 사용자가 쓴 글은 덮지 않는다. 템플릿이 없는 토픽은 빈 칸.
 */
export const contactTemplate: Record<string, string> = {
	[WORKS_WITH_TOPIC]: [
		'Request: Add / Correct',
		'Manufacturer:',
		'Device:',
		'MIDI implementation (manual link or page):',
		'What is wrong (correction only):',
		'',
	].join('\n'),
}

/**
 * 토픽 값 → 고객용 영어 라벨. 고객에게 나가는 글(이메일 제목 · My Messages)은 이것만 쓴다 —
 * 백오피스의 한글 라벨(INQUIRY_CATEG_LABEL)이 이메일 제목에 섞여 나간 일이 있다(2026-10-06).
 * 모르는 값은 'General'.
 */
export const contactTopicLabel = (value: string): string =>
	contactTopicList.find(aTopic => aTopic.value === value)?.label ?? 'General'

/** 토픽을 미리 고른 Contact 주소 */
export const contactPath = (topic: string) =>
	`/contact?topic=${encodeURIComponent(topic)}`
